import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const Container = styled.div`
  padding: ${spacing.majorScale(2)}px 0;
`
export const LicenseInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.majorScale(1)}px 0;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    flex-wrap: wrap;
    padding: ${spacing.majorScale(2)}px 0 ${spacing.majorScale(1)}px 0;
  }

  > * {
    flex: 1;
    margin: ${spacing.minorScale(3)}px 0;

    @media (min-width: ${breakpoints.lg}px) {
      flex: unset;
      width: 50%;
    }
  }
`
